import { useEffect, useRef } from 'react';

/**
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
export default function useInterval(
  callback: () => void,
  delay: number | null
) {
  const savedCallback = useRef<() => void | null | undefined>(undefined);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    return;
  }, [delay]);
}
